import { Box } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { primitive } from 'styles/constants/primitives';

export const ProductImageWrapper = Box.withConfig({
  flex: 1,
  background: primitive.$white,
});

export const StyledProductPicture = Picture.withConfig({
  width: '100%',
  alignSelf: 'center',
});

export const ProductInformationContainer = Box.withConfig({
  background: primitive.$white,
  width: 'full',
  paddingX: 4,
  alignItems: 'center',
  alignSelf: 'center',
});
